<template>
  <CourseBookSection editMode ref="sub-section"/>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CourseBookSection from '@/components/content/education/courses/CourseBookSection.vue'

export default {
  name: 'ContentCourseSubsection',
  components: {
    CourseBookSection
  },
  methods: {
    ...mapActions({
      fetchSubsection: 'education/fetchSubsection',
      clearCourseContent: 'education/clearCourseContent',
      setSubSectionPosition: 'education/setSubSectionPosition'
    }),
    ...mapMutations({
      clearCourseChanges: 'education/clearCourseChanges',
      setUpdater: 'contentManager/setUpdater',
      updateContentSavedStatus: 'contentManager/updateContentSavedStatus',
      freezeUpdater: 'contentManager/freezeUpdater'
    }),
    clearChanges() {
      this.clearCourseChanges()
      window.onbeforeunload = undefined
      const freeze = this.freeze // eslint-disable-line prefer-destructuring
      this.freezeUpdater(0)
      this.setUpdater(0)
      this.updateContentSavedStatus(true)
      this.freezeUpdater(freeze)
    },
    checkUpdate() {
      if (!this.isContentSaved && this.updater > 0) {
        // eslint-disable-next-line no-alert
        const answer = window.confirm('Имеются несохранённые изменения. Вы точно хотите закрыть страницу?')
        if (answer) {
          this.clearChanges()
          return true
        }
        this.freezeUpdater(0)
        return false
      }
      return true
    }
  },
  computed: {
    ...mapGetters({
      isContentSaved: 'contentManager/isContentSaved',
      updater: 'contentManager/getUpdater',
      freeze: 'contentManager/getFreeze'
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (this.checkUpdate() && this.$refs['sub-section']) {
      this.$refs['sub-section'].onBeforeRouteUpdate(to, from, next)
    } else {
      next(false)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.checkUpdate() && this.$refs['sub-section']) {
      this.$refs['sub-section'].onBeforeRouteLeave(to, from, next)
    } else {
      next(false)
    }
  }
}
</script>

<style scoped>

</style>
